module.exports = __webpack_public_path__ + "static/media/gabe_schuyler.787ddc27.jpg";